import React from "react";
import { Utensils, ShoppingBag } from "lucide-react";
import { checkStoreStatus } from "../../utils/storeHours";
import { useUser } from "../../context/UserContext";

export default function CheckoutTypeSelection({ onSelect, selectedType, forcedOpen = false }) {
  const { user } = useUser();
  const firstName = user?.first_name ? user.first_name.trim().split(" ")[0] : "";
  const baseClass =
    "group rounded-3xl border p-5 text-left transition-all duration-200";
  const activeClass =
    "border-[#fa9324] bg-[#fa9324] text-black shadow-[0_10px_25px_rgba(0,0,0,0.35)]";
  const inactiveClass =
    "border-white/15 bg-white/5 text-white [@media(hover:hover)]:hover:border-[#fa9324] [@media(hover:hover)]:hover:bg-[#fa9324] [@media(hover:hover)]:hover:text-black";

  const iconWrapper = (active, disabled = false) =>
    `flex h-11 w-11 shrink-0 items-center justify-center rounded-full ${
      active
        ? "bg-black/10 text-black"
        : `border border-white/15 bg-white/10 text-white ${!disabled ? "[@media(hover:hover)]:group-hover:border-black/10 [@media(hover:hover)]:group-hover:bg-black/10 [@media(hover:hover)]:group-hover:text-black" : ""}`
    }`;

  const { isEatInOpen: isEatInOpenSchedule } = checkStoreStatus();
  const isEatInOpen = isEatInOpenSchedule || forcedOpen;

  return (
    <section>
      <div className="mb-6">
        <h3 className="mt-2 text-xl text-white">
          {firstName ? `How would you like your order, ${firstName}?` : "How would you like your order?"}
        </h3>
      </div>

      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        
        {/* Eat In */}
        <button
          type="button"
          onClick={() => isEatInOpen && onSelect("eat-in")}
          disabled={!isEatInOpen}
          className={`${baseClass} ${
            selectedType === "eat-in" 
              ? activeClass 
              : isEatInOpen ? inactiveClass : "border-white/15 bg-white/5 text-white"
          } ${!isEatInOpen ? "opacity-50 cursor-not-allowed pointer-events-none" : ""}`}
        >
          <div className="flex items-start justify-between gap-4">
            <div>
              <div className="text-lg font-semibold">Eat In</div>
              <div
                className={`mt-2 text-sm ${
                  selectedType === "eat-in"
                    ? "text-black/75"
                    : `text-white/75 ${isEatInOpen ? "[@media(hover:hover)]:group-hover:text-black/75" : ""}`
                }`}
              >
                I'm in the restaurant
              </div>
            </div>

            <div className={iconWrapper(selectedType === "eat-in", !isEatInOpen)}>
              <Utensils size={20} />
            </div>
          </div>
        </button>

        {/* Pickup */}
        <button
          type="button"
          onClick={() => onSelect("pickup")}
          className={`${baseClass} ${
            selectedType === "pickup" ? activeClass : inactiveClass
          }`}
        >
          <div className="flex items-start justify-between gap-4">
            <div>
              <div className="text-lg font-semibold">Pick Up</div>
              <div
                className={`mt-2 text-sm ${
                  selectedType === "pickup"
                    ? "text-black/75"
                    : "text-white/75 [@media(hover:hover)]:group-hover:text-black/75"
                }`}
              >
                I'll come collect my order
              </div>
            </div>

            <div className={iconWrapper(selectedType === "pickup")}>
              <ShoppingBag size={20} />
            </div>
          </div>
        </button>

      </div>
    </section>
  );
}